// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectRole {
  margin-left: 10px;
  font-size: small;
  color: var(--ion-header-text) !important;
}

.icon-green {
  color: #008000 !important;
}

.label {
  font-size: 14px;
}

.terms {
  font-size: 14px;
  color: #234879 !important;
  text-decoration: underline !important;
  white-space: pre-wrap;
}

.Sign {
  margin-top: 18px;
  text-align: center;
}

.lbl-txt {
  white-space: pre-wrap;
}

:host ::ng-deep ion-intl-tel-input.signup-contact-number .ion-intl-tel-input-number {
  text-align: left !important;
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/signup/signup.page.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,gBAAA;EACA,wCAAA;AACF;;AACA;EACE,yBAAA;AAEF;;AAAA;EACE,eAAA;AAGF;;AADA;EACE,eAAA;EACA,yBAAA;EACA,qCAAA;EACA,qBAAA;AAIF;;AAFA;EACE,gBAAA;EACA,kBAAA;AAKF;;AAHA;EACE,qBAAA;AAMF;;AAHA;EACE,2BAAA;AAMF","sourcesContent":[".SelectRole {\n  margin-left: 10px;\n  font-size: small;\n  color: var(--ion-header-text) !important;\n}\n.icon-green {\n  color: #008000 !important;\n}\n.label {\n  font-size: 14px;\n}\n.terms {\n  font-size: 14px;\n  color: #234879 !important;\n  text-decoration: underline !important;\n  white-space: pre-wrap;\n}\n.Sign {\n  margin-top: 18px;\n  text-align: center;\n}\n.lbl-txt {\n  white-space: pre-wrap;\n}\n\n:host ::ng-deep ion-intl-tel-input.signup-contact-number .ion-intl-tel-input-number {\n  text-align: left !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
